import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { HashRouter as Router } from "react-router-dom";

const root = document.getElementById("root");

ReactDOM.createRoot(root).render(
  <Router>
    <App />
  </Router>
);
